import React from "react";
import { noLocationSvg } from "../utils/svg";
import Button from "../utils/Button";

const NoLocation = () => {
  return (
    <div className="flex flex-col items-center gap-2 align-center text-center p-6">
      {noLocationSvg()}
      <p className="text-lg font-medium text-gray-500">
        Your Location is needed
      </p>
      <p className="text-md font-normal text-gray-400">
        We need your location to verify milestone completion and ensure
        everything's running smoothly.
      </p>
      <Button
        text={"Refresh"}
        onClick={() => window.location.reload()}
        size={"md"}
      />
    </div>
  );
};

export default NoLocation;
